module.exports = __webpack_public_path__ + "static/media/muna_kaki_walk.734acde8.gif";